/**
 * Admin Restaurant Service
 * Handles restaurant configuration management for admins
 */

import { api } from '@/lib/axios';
import type { Restaurant, UpdateRestaurantRequest } from '@/types/restaurant';
import type { MailerStatusResponse, SendTestEmailResponse, UpdateMailerSettingsRequest } from '@/types/restaurant';

export const adminRestaurantService = {
  /**
   * Get current restaurant (admin view with credentials)
   */
  async getRestaurant(): Promise<Restaurant> {
    const response = await api.get<Restaurant>('/v1/admin/restaurant');
    return response.data;
  },

  /**
   * Update restaurant settings
   */
  async updateRestaurant(data: UpdateRestaurantRequest): Promise<Restaurant> {
    const response = await api.patch<Restaurant>('/v1/admin/restaurant', data);
    return response.data;
  },

  /**
   * Get mailer configuration status
   */
  async getMailerStatus(): Promise<MailerStatusResponse> {
    const response = await api.get<MailerStatusResponse>('/v1/admin/restaurant/mailer_status');
    return response.data;
  },

  /**
   * Update mailer settings
   */
  async updateMailerSettings(data: UpdateMailerSettingsRequest): Promise<Restaurant> {
    const response = await api.patch<Restaurant>('/v1/admin/restaurant', data);
    return response.data;
  },

  /**
   * Send a test email to verify mailer configuration
   */
  async sendTestEmail(): Promise<SendTestEmailResponse> {
    const response = await api.post<SendTestEmailResponse>('/v1/admin/restaurant/send_test_email');
    return response.data;
  },
};
